import { z } from 'zod'

export const JwtContent = z.object({
  id: z.number(),
  email: z.string().email(),
  name: z.string(),
  surname: z.string().optional(),
  role: z.string().optional(), // DEPRECATED: Use roles array instead
  roles: z.array(z.string()).default([]), // RBAC role names
  perms: z.array(z.string()).default([]), // Permission strings
  limited: z.boolean(),
  type: z.string(),
  session_id: z.string(),
  exp: z.number(),
  orig_iat: z.number(),
  is_impersonation: z.boolean().optional(),
  impersonating_admin_id: z.number().optional(),
  acting_as_account_id: z.number().optional(),
  acting_as_type: z.string().optional(),
  original_account_id: z.number().optional(),
  is_sub_account: z.boolean().optional(),
  parent_account_id: z.number().optional()
})

export type JwtContent = z.infer<typeof JwtContent>

// export interface JwtContent {
//   id: number
//   email: string
//   name: string
//   surname?: string
//   role: string
//   limited: boolean
//   type: string
//   session_id: string
//   exp: number
//   orig_iat: number
// }
